import React from "react";
import { TitleProps } from "@pankod/refine-core";
import routerProvider from "@pankod/refine-react-router-v6";

const { Link } = routerProvider;

export const Title: React.FC<TitleProps> = ({ collapsed }) => (
  <Link to="/">
    {collapsed ? (
      <img
        src={"/images/white-logo-small.svg"}
        alt="small logo"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          padding: "12px",
        }}
      />
    ) : (
      <img
        src={"/images/relationship-matrix-logo-red.svg"}
        alt="logo"
        style={{
          width: "200px",
          padding: "12px",
        }}
      />
    )}
  </Link>
);
